// extracted by mini-css-extract-plugin
export var carrierIcon = "_vs-0";
export var carrierLogo = "_vs-1";
export var detailsSection = "_vs-2";